module.exports = __webpack_public_path__ + "static/media/bByrne.d8afeff6.jpeg";